import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { toast } from 'react-toastify';

import styles from './Login.module.scss';

import { useAxios } from "../../../AxiosHandler";
import { useTranslate } from "react-polyglot";
import Field from "../../Shared/Wizard/Field/Field";

import logo from '../../../Assets/Images/biotail_logo.svg';

function Login() {
    const navigate = useNavigate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [loading, setLoading] = useState(false);

    async function loginuser() {
        setLoading(true);
        await auth.signin(
            username,
            password
        ).then(data => {
            setLoading(false);

            if (localStorage.getItem("selectedCountry") == null) {
                localStorage.setItem("selectedCountry", "all");
                auth.setSelectedCountry("all");
            }

            let state = window.history.state;
            if (state != null && state.from != null) {
                navigate(state.from + window.location.search);
            } else {
                navigate("/" + window.location.search);
            }

            window.scrollTo(0, 0);
        }).catch(error => {
            setLoading(false);
            console.log(error);
            if (error.response?.status >= 500) {
                toast.error("Noe gikk galt.", { autoClose: 20000 });
            }
        });
    }

    function resetPassword() {
        return; // Remove this when we have a proper reset password function

        if (loading) return;

        setLoading(true);

        axios.single({
            url: "/api/users/passwordreset",
            method: "POST",
            data: {
                Username: username
            }
        }).then((res: any) => {
            setLoading(false);
            toast.success("E-post sendt med instruksjoner for tilbakestilling av passord");
        }).catch((err: any) => {
            setLoading(false);
            console.log(err);
            toast.error("Tilbakestilling av passord feilet");
        });
    }

    return (
        <div className={styles.logincontainer}>
            <div className={styles.card}>
                <div className={styles.cardtop}>
                    <div className={styles.logomark}>
                        <img src={logo} alt="Logo" />
                    </div>
                    <span className={styles.logotext}>AvlsPortal</span>
                </div>
                <div className={styles.cardbody}>
                    <div className={styles.welcometext}>
                        <h4>{t("login.page_name")}</h4>
                        <p>{t("login.login_info")}</p>
                    </div>
                    <div className={styles.loginform}>
                        <div className={styles.inputs}>
                            <div className={styles.inputfield}>
                                <Field
                                    type="input"
                                    title={t("login.username")}
                                    value={username}
                                    onChange={(value: any) => setUsername(value)}
                                    placeholder={t("login.username")}
                                    onKeyDown={(e: any) => {
                                        if (e.key == "Enter") loginuser();
                                    }}
                                    dataLpignore="true"
                                    autocomplete="off"
                                ></Field>
                            </div>
                            <div className={styles.inputfield}>
                                <Field
                                    type="password"
                                    title={t("login.password")}
                                    value={password}
                                    onChange={(value: any) => setPassword(value)}
                                    placeholder={t("login.password")}
                                    onKeyDown={(e: any) => {
                                        if (e.key == "Enter") loginuser();
                                    }}
                                    dataLpignore="true"
                                    autocomplete="off"
                                ></Field>
                            </div>
                        </div>
                        <div className={styles.buttonbox}>
                            <button onClick={loginuser} disabled={loading}>
                                {t("login.login")}
                            </button>
                            <button onClick={resetPassword}>
                                {t("login.lost_password")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
